var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zi-toggle",class:{ checked: !!_vm.model, disabled: _vm.disabled },on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }